export default __webpack_public_path__ + "fonts/tpl_10.62d32fd248c245b2eafdd1d61a366beb.png";